<div class="card m-6">
    <div class="flex justify-between items-center mb-4">
        <h2 class="text-2xl font-bold">Usuários</h2>
        <p-button 
            label="Adicionar" 
            icon="pi pi-plus" 
            (onClick)="navigateToCreate()" 
            severity="success" />
    </div>

    <div class="mb-4">
        <input 
            type="text" 
            pInputText 
            [(ngModel)]="searchTerm" 
            placeholder="Pesquisar usuários..." 
            class="w-full"
            (input)="onSearchChange(searchTerm)" />
    </div>

    <p-table 
        [value]="users" 
        [paginator]="true" 
        [rows]="10" 
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} usuários"
        [tableStyle]="{'min-width': '50rem'}"
        styleClass="p-datatable-striped">
        
        <ng-template #header>
            <tr>
                <th style="width:8%">ID</th>
                <th style="width:20%">Nome</th>
                <th style="width:25%">Email</th>
                <th style="width:15%">Função</th>
                <th style="width:12%">CNH</th>
                <th style="width:20%">Ações</th>
            </tr>
        </ng-template>
        
        <ng-template #body let-user>
            <tr>
                <td>{{ user.id }}</td>
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>
                    <p-tag 
                        [value]="user.role || 'N/A'" 
                        severity="info" />
                </td>
                <td>{{ user.cnh || 'N/A' }}</td>
                <td>
                    <div class="flex gap-2">
                        <p-button 
                            icon="pi pi-pencil" 
                            severity="info" 
                            size="small"
                            (onClick)="editUser(user.id)"
                            pTooltip="Editar" />
                        <p-button 
                            icon="pi pi-trash" 
                            severity="danger" 
                            size="small"
                            (onClick)="deleteUser(user.id)"
                            pTooltip="Excluir" />
                    </div>
                </td>
            </tr>
        </ng-template>
        
        <ng-template #empty>
            <tr>
                <td colspan="6" class="text-center py-4">
                    Nenhum usuário encontrado.
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
